import ContactItem from "components/elements/contact_item";
import SkillItem from "components/elements/skill_item";
import HomeSectionFrame from "components/elements/home_section_frame";
import FrameGlassCard from "components/views/frame_glass_card";
import ButtonGradient from "components/elements/button_gradient";
import ProfilePicture from "assets/images/profile_picture.png";
import HeroLeftCircles from "assets/illustrations/hero_left_circles.svg";
import HeroRightCircles from "assets/illustrations/hero_right_circles.svg";
import { listContact, listSkill, listSocialMedia } from "utils/other/constants";
import { Box, CardMedia, Typography } from "@mui/material";
import { Fragment, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { NAVIGATION_SET_MENU } from "utils/redux/action";
import {
  BoxMotion,
  TypographyMotion,
} from "components/elements/material_motion";

export default function HomePage() {
  const dispatcher = useDispatch();
  const buttonDetailRef = useRef(null);

  useEffect(() => {
    dispatcher({ type: NAVIGATION_SET_MENU, index: 0 });
  }, [dispatcher]);

  return (
    <Fragment>
      <BoxMotion
        initial={{ opacity: 0, scale: 0, rotate: -180 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ type: "spring", delay: 0.0, duration: 1 }}
      >
        <FrameGlassCard>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              padding: {
                xs: "30px",
                md: "30px 0",
                lg: "40px 0",
              },
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: { xs: 4, md: 8, lg: 10 },
            }}
          >
            <CardMedia
              component="img"
              src={HeroLeftCircles}
              sx={{
                position: "absolute",
                zIndex: -1,
                bottom: 0,
                left: "18%",
                width: "auto",
              }}
            />
            <CardMedia
              component="img"
              src={HeroRightCircles}
              sx={{
                position: "absolute",
                zIndex: -1,
                bottom: 0,
                right: 0,
                width: "auto",
              }}
            />
            <BoxMotion
              initial={{ x: "-100%", y: "100%", opacity: 0, scale: 0 }}
              animate={{ x: 0, y: 0, opacity: 1, scale: 1 }}
              transition={{ type: "spring", delay: 0.2, duration: 1 }}
              sx={{ flex: 1, position: "relative" }}
            >
              <Box
                sx={{
                  aspectRatio: 1,
                  width: { xs: "50vw", md: "100%" },
                  position: "relative",
                  boxSizing: "border-box",
                  marginLeft: { xs: -8, md: 0 },
                  borderRadius: {
                    xs: "1000px",
                    md: "1000px 1000px 1000px 0px",
                  },
                  outline: "8px solid rgba(255, 255, 255, 0.20)",
                  background:
                    "radial-gradient(267.72% 139.47% at 0% 2.78%, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.00) 100%)",
                  backdropFilter: "blur(25px)",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: { xs: 10, md: 30 },
                    right: { xs: 0, md: 20 },
                    left: 0,
                    bottom: { xs: -10, md: -20 },
                    backgroundImage: `url("${ProfilePicture}")`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPositionX: "center",
                    backgroundPositionY: "bottom",
                  }}
                />
              </Box>
            </BoxMotion>
            <Box
              sx={{
                flex: 2,
                padding: { xs: 0, md: "20px 50px 0 0" },
                boxSizing: "border-box",
              }}
            >
              <TypographyMotion
                initial={{ x: "70vw", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ type: "spring", delay: 0.2, duration: 1 }}
                variant="h1"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  fontSize: { xs: 18, sm: 24, md: 32, lg: 42 },
                  marginBottom: { xs: 1, sm: 2, md: 3 },
                }}
              >
                Hi, Saya Rangga
                <br />
                Seorang Mobile Developer !
              </TypographyMotion>
              <TypographyMotion
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ type: "spring", delay: 0.3, duration: 1 }}
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: { xs: 14, sm: 16, md: 14, lg: 18 },
                  marginBottom: 1,
                  color: "rgba(0,0,0,0.8)",
                }}
              >
                Tentang Saya
              </TypographyMotion>
              <TypographyMotion
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ type: "spring", delay: 0.4, duration: 1 }}
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 300,
                  fontSize: { xs: 14, sm: 16, md: 14, lg: 18 },
                  color: "rgba(0,0,0,0.8)",
                  marginBottom: { xs: 2, md: 3, lg: 5 },
                  paddingRight: { xs: 7, md: 0 },
                }}
              >
                Perkenalkan saya Rangga Wiraguna Rudiyanto, lahir di Jakarta
                pada tanggal 20 Juni 2000. Saya memiliki beberapa pengalaman
                bekerja sebagai Mobile Developer untuk beberapa Aplikasi
                Android/iOS yang dibangun menggunakan Framework Flutter ataupun
                bahasa pemrograman Java. Selain itu, saya juga memiliki
                sertifikasi resmi terkait Software Development yaitu Pelatihan
                Junior Web Development yang didapatkan dari Badan Nasional
                Sertifikasi Profesi (BNSP) pada Oktober 2021 silam.
              </TypographyMotion>
              <BoxMotion
                initial={{ y: 100, scaleZ: 0, opacity: 0 }}
                animate={{ y: 0, scaleZ: 1, opacity: 1 }}
                transition={{ type: "spring", delay: 0.5, duration: 1 }}
              >
                <ButtonGradient
                  text={"Lihat Selengkapnya"}
                  borderRadius="12px"
                  onClick={() =>
                    buttonDetailRef?.current?.scrollIntoView({
                      behavior: "smooth",
                    })
                  }
                />
              </BoxMotion>
            </Box>
          </Box>
        </FrameGlassCard>
      </BoxMotion>
      <Box ref={buttonDetailRef} height={40} />
      <BoxMotion
        initial={{ x: -30, opacity: 0 }}
        animate={{ x: -0, opacity: 1 }}
        transition={{ type: "spring", delay: 0.2, duration: 1 }}
      >
        <HomeSectionFrame>
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 700,
              fontSize: { xs: 16, md: 18 },
              textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
            }}
          >
            Kemampuan
          </Typography>
        </HomeSectionFrame>
      </BoxMotion>
      <Box whiteSpace={"pre-wrap"} height={20} />
      <BoxMotion
        initial={{ x: -30, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ type: "spring", delay: 0.4, duration: 1 }}
      >
        <HomeSectionFrame fullwidth>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {listSkill.map((_, __) => (
              <SkillItem key={__} text={_} />
            ))}
          </Box>
        </HomeSectionFrame>
      </BoxMotion>
      <Box whiteSpace={"pre-wrap"} height={40} />
      <Box
        sx={{
          display: "flex",
          gap: 5,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box sx={{ flex: 1 }}>
          <BoxMotion
            initial={{ x: -30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", delay: 0.6, duration: 1 }}
          >
            <HomeSectionFrame>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  fontSize: { xs: 16, md: 18 },
                  textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
                }}
              >
                Kontak
              </Typography>
            </HomeSectionFrame>
          </BoxMotion>
          <Box whiteSpace={"pre-wrap"} height={20} />
          <BoxMotion
            initial={{ x: -30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", delay: 0.8, duration: 1 }}
          >
            <HomeSectionFrame fullwidth>
              {listContact.map((_, __) => (
                <ContactItem key={__} item={_} />
              ))}
            </HomeSectionFrame>
          </BoxMotion>
        </Box>
        <Box sx={{ flex: 1 }}>
          <BoxMotion
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", delay: 0.6, duration: 1 }}
          >
            <HomeSectionFrame>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  fontSize: { xs: 16, md: 18 },
                  textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
                }}
              >
                Sosial Media
              </Typography>
            </HomeSectionFrame>
          </BoxMotion>
          <Box whiteSpace={"pre-wrap"} height={20} />
          <BoxMotion
            initial={{ x: 30, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", delay: 0.8, duration: 1 }}
          >
            <HomeSectionFrame fullwidth>
              {listSocialMedia.map((_, __) => (
                <ContactItem key={__} item={_} />
              ))}
            </HomeSectionFrame>
          </BoxMotion>
        </Box>
      </Box>
    </Fragment>
  );
}
